import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';
import { TRIGGER_CHART_TYPES } from '/src/features/goals/constants';
import { SPECIAL_DATE_RANGES } from '../_global/constants';

export const goalSelectedDatesAtom = atomWithDefault(() => {
  const params = new URLSearchParams(window.location.search);
  const dateRange = params.get('date_range') || SPECIAL_DATE_RANGES.LAST_7_DAYS;

  switch (dateRange) {
    case SPECIAL_DATE_RANGES.TODAY:
    case SPECIAL_DATE_RANGES.LAST_7_DAYS:
    case SPECIAL_DATE_RANGES.LAST_30_DAYS:
    case SPECIAL_DATE_RANGES.THIS_MONTH:
    case SPECIAL_DATE_RANGES.LAST_MONTH:
      return {
        special: dateRange,
        startDate: null,
        endDate: null,
      };
    default: {
      if (!dateRange.includes('-')) {
        return {
          special: SPECIAL_DATE_RANGES.LAST_7_DAYS,
          startDate: null,
          endDate: null,
        };
      }

      const parts = dateRange.split('-').map((part) => Number.parseInt(part.trim(), 10));

      if (parts.length !== 2 || !parts.every(Number.isFinite)) {
        return {
          special: SPECIAL_DATE_RANGES.LAST_7_DAYS,
          startDate: null,
          endDate: null,
        };
      }

      const [startDate, endDate] = parts;

      return {
        special: null,
        startDate,
        endDate,
      };
    }
  }
});

export const goalDetailSelectedTriggerType = atom(TRIGGER_CHART_TYPES.SEPARATE);
